<div class="content">
	<table mat-table [dataSource]="dataSource" >

		<ng-container matColumnDef="bucket">
			<th mat-header-cell *matHeaderCellDef>Bucket</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.bucket}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="key">
			<th mat-header-cell *matHeaderCellDef >Key</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.key}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="download">
			<th mat-header-cell *matHeaderCellDef >download</th>
			<td mat-cell *matCellDef="let _row" >
				<button mat-icon-button color="primary">
					<mat-icon>download</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="download(row)" >
		</tr>

	</table>

</div>

